module.exports = __webpack_public_path__ + "static/media/29-mercedes.d5bf61e5.jpg";